import { useState } from 'react';
import Wizard from './components/wizard/Wizard';
import { Container, Typography, Box, CssBaseline } from '@mui/material';

const App = () => {
  const [user, setUser] = useState(null);

  const devMode = new URLSearchParams(window.location.search).get('dev') === '1';

  return (
    <>
      <CssBaseline />
      <Box sx={{ position: 'relative' }}>
        <Container maxWidth="md">
          <Box py={4} textAlign="center">
            <Typography variant="h3" component="h1" gutterBottom>
              📘 Binder
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              v0.11.0
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Select documents (PDF, JPG, PNG, GIF, or photos), describe each one using custom fields, and generate a single PDF with a summary cover page. 
              Everything is processed 100% locally in your browser — on desktop or mobile. 
              <br />
              No uploads, no ads, no tracking.
            </Typography>
          </Box>

          <Wizard devMode={devMode} user={user} setUser={setUser} />
        </Container>
      </Box>
    </>
  );
};

export default App;
